/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import { Request } from './request';

export class Sender {
  private request: Request;

  constructor(private requests: Request[]) {
    this.request = (this.requests as any).find((request: Request) => request.isAvailable());
  }

  public send(data: string | Uint8Array): boolean {
    return this.request.send(data);
  }
}
